import {USER_DATA} from 'src/app/_interfaces/auth.interface'
import {UserSubscriptionPlan} from 'src/interfaces/Platform.interface'

export const FREE_TRIAL_28_DISPLAY_NAME = 'free trial - 28 days'

export const initialOnboardingTourSteps = {
  stepOne: 'active' as const,
  stepTwo: 'inactive' as const,
  stepThree: 'inactive' as const,
}

export const isActiveFreeTrial28DaySubscription = (
  subscription: UserSubscriptionPlan | null | undefined
): boolean => {
  if (!subscription?.isActive) {
    return false
  }
  const plan = subscription.billing_plan as UserSubscriptionPlan['billing_plan'] & {
    plan_type?: string
  }
  if (!plan) {
    return false
  }
  const displayName = String(plan.display_name || '').trim().toLowerCase()
  return (
    plan.billing_frequency === 'FREE_FOREVER' &&
    plan.plan_type === 'COMMON' &&
    displayName.startsWith(FREE_TRIAL_28_DISPLAY_NAME)
  )
}

export const isDeferredFreeTrialOnboardingUser = (
  account: USER_DATA | null | undefined,
  subscription: UserSubscriptionPlan | null | undefined
): boolean => {
  if (!account || account.user_type !== 'USER') {
    return false
  }
  if (!account.isPhoneNumberStepDone) {
    return false
  }
  if (account.isOnboardingProcessCompleted === true) {
    return false
  }
  if (!account.is_subscribed) {
    return false
  }
  return isActiveFreeTrial28DaySubscription(subscription)
}

export const mightNeedDeferredFreeTrialPlanCheck = (
  account: USER_DATA | null | undefined
): boolean => {
  if (!account || account.user_type !== 'USER') {
    return false
  }
  return (
    account.isPhoneNumberStepDone === true &&
    account.isOnboardingProcessCompleted !== true &&
    account.is_subscribed === true
  )
}
